import { ModalGeneric } from 'ypf-pas-general-ui-components';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { workReportLineStatus } from '../../../utils/dataStatus';

import './ProgramPointModal.scss';

import ProgramPointList from './ProgramPointList/ProgramPointList';
import useLocationProgramPoints from './useLocationProgramPoints';

const ProgramPointModalFormik = ({ show, onHide, ...props }) => {
  const {
    line,
    disabledPPModal,
    tienePuntosPrograma,
    setIsRectifyAmount,
    isRectifyAmount,
    selectedDate,
    setNewFetch
  } = props;

  const [showAlert, setShowAlert] = useState(false);

  const {
    calculateTotalValue,
    getProgramPointsData,
    postLocationProgramPoints,
    rectifyLocationProgramPoints,
    loading,
    resetForm,
    setFieldValue,
    values
  } = useLocationProgramPoints({
    line,
    isRectify: isRectifyAmount
  });

  const onExit = () => {
    resetForm();
    setIsRectifyAmount(false);
    setNewFetch((oldValue) => !oldValue);
    onHide();
  };

  useEffect(() => {
    if (show) getProgramPointsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handlePostProgramPoints = async (locations) => {
    if (isRectifyAmount) {
      await rectifyLocationProgramPoints(values?.locationTotalValue, locations);
    } else {
      await postLocationProgramPoints(locations);
    }
    onExit();
  };

  const disabledToEdit =
    (line?.estadoEnum === workReportLineStatus.fijar && tienePuntosPrograma) ||
    (line?.estadoEnum === workReportLineStatus.aprobar && tienePuntosPrograma);

  const disabledInput =
    !isRectifyAmount &&
    line?.estadoEnum !== workReportLineStatus.pendiente &&
    line?.estadoEnum !== workReportLineStatus.devolver &&
    line?.estadoEnum !== workReportLineStatus.enviar;

  const disabledNotifyWithPPwithoutRect =
    line?.estadoEnum === workReportLineStatus.enviar && tienePuntosPrograma && !isRectifyAmount;

  useEffect(() => {
    const hasCompleteData = values.locations.every(
      (location) =>
        Array.isArray(location.programPoints) &&
        location.programPoints.every(
          (PP) => PP && typeof PP === 'object' && 'code' in PP && 'subCode' in PP && 'cost' in PP
        )
    );

    if (hasCompleteData) {
      setShowAlert(
        values.locations.some(
          (location) =>
            Array.isArray(location.programPoints) &&
            location.programPoints.some(
              (programPoint) =>
                programPoint?.code === null ||
                programPoint?.code === '' ||
                programPoint?.subCode === null ||
                programPoint?.subCode === '' ||
                programPoint?.cost === null ||
                programPoint?.cost === '' ||
                programPoint?.cost?.nombre === '' ||
                programPoint?.code?.nombre === '' ||
                programPoint?.subCode?.nombre === ''
            )
        )
      );
    } else {
      setShowAlert(true);
    }
  }, []);

  const hasTotalValuesChange = JSON.stringify(
    values.locations.map((location) => location.totalValue)
  );

  useEffect(() => {
    const { locationTotalValue, locationTotalValueFijado } = calculateTotalValue(values.locations);

    setFieldValue(`locationTotalValue`, locationTotalValue);
    setFieldValue(`locationTotalValueFijado`, locationTotalValueFijado);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasTotalValuesChange]);

  // const isRectifyToZero =
  //   isRectifyAmount &&
  //   !values?.locations
  //     .filter((location) => location.habilitaVentana === false)
  //     .flatMap((location) => location.programPoints)
  //     .every((programPoint) => {
  //       const quantityValue = programPoint.quantity;

  //       return quantityValue === null || quantityValue === 0 || quantityValue === '';
  //     });

  const validationRectiy = () => {
    const programPoints = values.locations
      .filter((loc) => loc.habilitaVentana)
      .flatMap((location) => location.programPoints || []);

    if (programPoints.length === 0) return false;

    if (isRectifyAmount) {
      const allZero = programPoints.every((pp) => Number(pp.quantity) === 0);
      const allPositive = programPoints.every((pp) => Number(pp.quantity) > 0);

      return allZero || allPositive;
    }

    return programPoints.every((pp) => Number(pp.quantity) > 0);
  };

  return (
    <ModalGeneric
      backdrop
      infoModal
      onHide={onExit}
      primaryAction={() => {
        handlePostProgramPoints(values?.locations);
      }}
      primaryActionDisabled={
        !validationRectiy() ||
        // values?.locations
        //   .filter((loc) => loc.habilitaVentana)
        //   .flatMap((location) => location.programPoints || [])
        //   .find((qntyObj) => !qntyObj.quantity) ||
        disabledPPModal ||
        disabledToEdit ||
        disabledNotifyWithPPwithoutRect ||
        values?.locations
          .filter((loc) => loc.habilitaVentana)
          .flatMap((location) => location.programPoints || [])
          .find(
            (qntyObj) =>
              qntyObj.quantity &&
              !qntyObj.points &&
              !isRectifyAmount &&
              line?.estadoEnum !== workReportLineStatus.devolver
          )
      }
      primaryActionLabel="Enviar a Aprobar"
      secondaryAction={onExit}
      secondaryActionLabel="Salir"
      show={show}
      size="xl"
      title="Editar Puntos de Programa"
    >
      <ProgramPointList
        dailyView
        disabledButton={disabledInput || disabledNotifyWithPPwithoutRect}
        disabledInputPP={
          disabledInput || disabledPPModal || disabledToEdit || disabledNotifyWithPPwithoutRect
        }
        disabledInputQuantity={
          disabledInput || disabledToEdit || disabledPPModal || disabledNotifyWithPPwithoutRect
        }
        displayButtons={
          !disabledToEdit && !disabledPPModal && !disabledInput && !disabledNotifyWithPPwithoutRect
        }
        displayFixedlabel
        eventoSigla={line?.eventoSigla}
        idParteDiario={line?.idParteDiario}
        isLocation
        line={line}
        loading={loading}
        selectedDate={selectedDate}
        setFieldValue={setFieldValue}
        showAlert={showAlert}
        showTitle
        tipoAsignacion={line?.tipoAsignacion}
        values={values}
        viewCSA
        viewInputs
      />
    </ModalGeneric>
  );
};

ProgramPointModalFormik.displayName = 'ProgramPointModalFormik';
ProgramPointModalFormik.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  line: PropTypes.shape({
    positionName: PropTypes.string,
    lineName: PropTypes.string,
    idParteDiario: PropTypes.number,
    estadoEnum: PropTypes.number,
    tienePuntosPrograma: PropTypes.bool,
    tipoAsignacion: PropTypes.number
  }),
  amount: PropTypes.number,
  setAmount: PropTypes.func,
  disabledPPModal: PropTypes.bool,
  setIsRectifyAmount: PropTypes.func,
  isRectifyAmount: PropTypes.bool,
  tienePuntosPrograma: PropTypes.bool,
  selectedDate: PropTypes.string,
  setNewFetch: PropTypes.func
};

ProgramPointModalFormik.defaultProps = {
  amount: 0,
  setAmount: () => {},
  line: {},
  tienePuntosPrograma: false,
  disabledPPModal: false,
  setIsRectifyAmount: () => {},
  isRectifyAmount: false,
  selectedDate: '',
  setNewFetch: () => {}
};
export default ProgramPointModalFormik;
